
export const baseEmailConfig = {
  sender: 'Briefr <redaksjonen@briefr.no>',
  subject: 'Forespørsel om kommentar til aktuell artikkel',
  baseUrl: 'https://briefr.no'
};
